import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseFormControl } from '../components/base-form-control/Component.js';

var defaultColors = {"inner":"form-control__inner_1u8yp","disabled":"form-control__disabled_1u8yp","hasError":"form-control__hasError_1u8yp"};
require('./default.mobile.css')

var invertedColors = {"inner":"form-control__inner_3fd82","disabled":"form-control__disabled_3fd82","hasError":"form-control__hasError_3fd82"};
require('./inverted.mobile.css')

var styles = {"above":"form-control__above_1fhlx","sub":"form-control__sub_1fhlx","error":"form-control__error_1fhlx","size-40":"form-control__size-40_1fhlx","inner":"form-control__inner_1fhlx","size-48":"form-control__size-48_1fhlx","size-56":"form-control__size-56_1fhlx","size-64":"form-control__size-64_1fhlx","size-72":"form-control__size-72_1fhlx"};
require('./mobile.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var FormControlMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseFormControl, __assign({}, restProps, { ref: ref, styles: styles, colorStyles: colorStyles }))); });

export { FormControlMobile };
